import { useParams } from "react-router-dom";
import { getVideoDetail } from "../../helper/useApiHelper";
import VideoDetails from "../../components/VideoDetails";
import LoadingComponent from "../../components/LoadingCard";
import { useErrorState } from "../../contexts/errorContext";

const VideoScreen = () => {
  const { videoId } = useParams();
  const { data, isLoading, error } = getVideoDetail(videoId);
  const { setIsError } = useErrorState();

  if (error || (data && data.data.status === false)) {
    setIsError(true);
    return <h1>Error</h1>;
  }

  if (isLoading) {
    return <LoadingComponent isDetail />;
  }
  return (
    <>
      {data && (
        <VideoDetails
          videoId={videoId}
          title={data.data.title}
          thumbnail={data.data.thumbnailUrl}
          owner={data.data.owner}
          views={data.data.views}
          datePublished={data.data.datePublished}
          genre={data.data.genre}
          description={data.data.description}
          thumbnailUrl={data.data.thumbnailUrl}
        />
      )}
    </>
  );
};

export default VideoScreen;
